const productFormBtn = document.querySelector(".pdp-add-cart-btn");
const selectQty = document.querySelector(
  ".shopify-product-form .custom-select"
);
let hasTabVersion = document.querySelector(".product-tab-container") !== null;
const productDetailsPage = document.querySelector("body.product");
const productVariants = document.querySelectorAll(".product-as-variant");
let currUrl =
  sessionStorage.getItem("currUrl") != null
    ? sessionStorage.getItem("currUrl")
    : document.location.href;

if (
  productDetailsPage &&
  performance.navigation.type == performance.navigation.TYPE_RELOAD
) {
  sessionStorage.setItem("prevLink", sessionStorage.getItem("prevLink"));
} else if (
  productDetailsPage &&
  document.referrer.includes("order.buywithprime.amazon.com")
) {
  sessionStorage.setItem("prevLink", sessionStorage.getItem("prevLink"));
} else if (productDetailsPage && currUrl != document.referrer) {
  sessionStorage.setItem("prevLink", document.referrer);
}

let prevLink = sessionStorage.getItem("prevLink");

if (prevLink != null && prevLink.includes("shop-amazon-prime")) {
  productFormBtn.style.display = "none";
  selectQty.style.display = "none";
  let radios = document.getElementsByName("quantity");
  let value = "1";

  for (let i = 0, length = radios.length; i < length; i++) {
    if (radios[i].value == value) {
      radios[i].checked = true;
      break;
    }
  }

  if (hasTabVersion) {
    const productTabContainer = document.querySelector(
      ".product-tab-container"
    );
    const productTabPanelF = document.querySelector("#product-tab-panel-0");
    const productTabPanelL = document.querySelector("#product-tab-panel-1");
    productTabContainer.style.display = "none";
    productTabPanelF.style.display = "none";
    productTabPanelL.style.display = "block";
  }
} else {
  sessionStorage.removeItem("currUrl");
  productFormBtn.style.display = "block";
  selectQty.style.display = "block";
}

productVariants.forEach((productVariant) => {
  productVariant.addEventListener("click", function (e) {
    sessionStorage.setItem("currUrl", document.location.href);
  });
});

//BWP Qty

function getVariantById(data, id) {
  return data.filter(function (data) {
    return data.id == id;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let qtyAll = document.querySelectorAll("input[name='quantity']");
  let bwpContainerDiv = document.querySelector("#amzn-buy-now");
  let bwpIframe = document.querySelector("#bwpFrame");
  let widgetLoaded = document.querySelector(".bwp-widget-loaded");

  const getQuantity = () => {
    return document.querySelector("input[name='quantity']:checked");
  };

  function triggerUpdate() {
    let variantValId;
    let quantityInput = document.querySelector(
      "input[name='quantity']:checked"
    ).value;

    if (hasTabVersion) {
      variantValId = document.querySelector(
        ".tabMultiQty input[name='id']"
      ).value;
    } else {
      variantValId = document.querySelector("input[name='id']").value;
    }

    let selectedVariant = getVariantById(meta.product.variants, variantValId);
    let dataSKU = selectedVariant[0].sku;
    let variantSkus = [];

    window.bwp.updateWidget(dataSKU, quantityInput, variantSkus);
  }

  let inputQuantity = getQuantity();
  qtyAll.forEach((qty) => {
    qty.addEventListener("change", function () {
      setTimeout(triggerUpdate, 1000);
    });
  });

  if (bwpIframe) {
    setTimeout(function () {
      if (bwpIframe.contentWindow) {
        triggerUpdate();
      }
    }, 2000);
  }
});
